import { Injectable } from '@angular/core';
import { Cart } from '@cargos/sprintpay-models';
import { Observable } from 'rxjs';
import { InitialConfigurationService } from './initial-configuration.service';

@Injectable({
    providedIn: 'root',
})
export class CartHandlerService {
    constructor(private initialConfigurationService: InitialConfigurationService) {}

    getCartRequest$(): Observable<Cart> {
        return this.initialConfigurationService.getCart();
    }
}
